import { FormControlLabel, Switch } from '@material-ui/core';
import React from 'react';
import { Hint } from 'v2/components/Shared/Hint';

import type { FieldProps } from 'formik';

interface IProps extends FieldProps {
  label?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SwitchFormField = ({ field, form, label, ...props }: IProps) => (
  <Hint inputName={field.name}>
    <FormControlLabel label={label} {...field} {...props} control={<Switch color='default' checked={field.value} {...field} {...props} />} />
  </Hint>
);
